module.exports = __webpack_public_path__ + "static/img/COC2021-2.4319172.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-2.jpg
// module id = vym/
// module chunks = 0